var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWorkspaceComputer = function SvgWorkspaceComputer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 21.2 19.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.6 19.2a.6.6 0 1 0 0-1.2v1.2m-8-1.2a.6.6 0 1 0 0 1.2V18m4.6-3.4a.6.6 0 1 0-1.2 0h1.2m3.4 4V18h-4v1.2h4zm-4 0V18h-4v1.2h4zm0-4H10v4h1.2v-4zm-7-14v.6h14V0h-14zm17 3H20v8h1.2v-8zm-3 11V14h-14v1.2h14zm-17-3h.6v-8H0v8zm3 3V14a2.4 2.4 0 0 1-2.4-2.4H0a3.6 3.6 0 0 0 3.6 3.6zm17-3H20a2.4 2.4 0 0 1-2.4 2.4v1.2a3.6 3.6 0 0 0 3.6-3.6zm-3-11v.6A2.4 2.4 0 0 1 20 3.6h1.2A3.6 3.6 0 0 0 17.6 0zm-14 0V0A3.6 3.6 0 0 0 0 3.6h1.2a2.4 2.4 0 0 1 2.4-2.4z"
  })));
};
export default SvgWorkspaceComputer;